import {React, useEffect} from 'react'
// import logo from './img/lgo.png' /* logo */
import logo2 from './img/lgo2.png' /* logo */
import './scroll.css'

/* CHANGE every Navabar into what u need */

function Nav() {
    useEffect(() => {
        const handleScroll = () => {
          const navbarMUKEDI = document.querySelector('.navbarMUKEDI');
          const logo = document.querySelector('.logo');
          const logox = document.querySelector('.logo-text');

          if (window.scrollY > 10) {
            navbarMUKEDI.classList.add('scrolled');
            logo.classList.add('hide-logo');
            logox.classList.add('hide-logo');
          } else {
            navbarMUKEDI.classList.remove('scrolled');
            logo.classList.remove('hide-logo');
            logox.classList.remove('hide-logo');
          }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

        function scrollToTop(event) {
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
          event.preventDefault();
          document.getElementById("scrollableDiv").scrollTo({
              top: 0,
              behavior: 'smooth'
          });
      }

    return (
      <div className='MUKEDI'>
        <div className="top-nav">
            <div className='logo-text'>
              <a href="adminMUKEDI">
                <img src={logo2} className="logo" style={{ width: '45px', position: 'fixed', top: 3, left: 5, zIndex: 1}} />
              </a>
{/* title */} <a href="adminMUKEDI" id='log-txt' className="logtex"><strong>
                INSTITUT SUPERIEUR PEDAGOGIQUE MUKEDI
              </strong></a>
            </div>
          <nav className="navbarMUKEDI">
          <ul className="nav-links">
                  {/* <li style={{ marginLeft: "350px" }}><a href="#academic"><strong>Academique</strong></a></li> */}
                  {/* <li><a href="#home"><strong>Bibliotheque</strong></a></li> */}
                  {/* <li><a href="#home"><strong>Inscription</strong></a></li>
                  <li><a href="gallery"><strong>Gallery</strong></a></li> */}
                  <li><a href="#home"><strong>Contact</strong></a></li>
                  <li><a href="login"><strong>Login</strong></a></li>
              </ul>
          </nav>
          <br/>
          <br/>
        </div>
      </div>
    )
}

export default Nav;